import styled from '@emotion/styled';

export const Container = styled.form`
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	margin-top: calc(${(props) => props.theme.heights.header} + 8rem);
	margin-bottom: 8rem;
	@media screen and (max-width: ${(props) => props.theme.breakpoints.layout}px) {
		margin-top: calc(${(props) => props.theme.heights.headerMobile} + 8rem);
		padding: 0 2rem;
	}
	.title {
		font-size: ${(props) => props.theme.fontSize.size4xl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
	}
`;
export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;
export const Button = styled.button`
	width: 100%;
	padding: 1.4rem 1.2rem;
	border: none;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;
export const MenuBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.8rem;
`;
export const MenuButton = styled.button`
	background-color: transparent;
	border: none;
	color: #868e96;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
`;
export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.4rem;
	width: 100%;
	height: 4.4rem;
	div {
		flex: 1;
	}
	input {
		flex: 1;
	}
`;
export const FindButton = styled.button`
	background-color: #212529;
	color: #fff;
	padding: 0 1.2rem;
	white-space: nowrap;
	min-width: 8rem;
	border: none;
	height: 100%;
	flex-shrink: 0; /* 버튼이 줄어들지 않도록 설정 */
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
		cursor: unset;
	}
`;
export const Danger = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: ${(props) => props.theme.colors.red600};
`;
